/** Languages the office portal currently promises to render. */
export type PortalLocale = 'en' | 'es-HN';

/**
 * The portal follows the browser, just as a website should when it has no saved portal preference.
 *
 * `languages` is injectable so a screen can be proved in both languages without changing the test
 * runner's process locale. Spanish from any country selects the Honduran catalog; every other
 * language falls back to English rather than leaving stable identifiers or half-translated copy on
 * screen.
 */
export function portalLocale(
  languages: readonly string[] = typeof navigator === 'undefined'
    ? []
    : navigator.languages.length
      ? navigator.languages
      : [navigator.language],
): PortalLocale {
  for (const language of languages) {
    if (/^es(?:-|$)/i.test(language)) return 'es-HN';
    if (/^en(?:-|$)/i.test(language)) return 'en';
  }
  return 'en';
}

/** Locale tag used by `Intl` for a portal language. */
export function intlLocale(locale: PortalLocale): 'en-US' | 'es-HN' {
  return locale === 'es-HN' ? 'es-HN' : 'en-US';
}
